var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":_vm.disable ? 'presentation' : 'button'},on:{"click":_vm.showCommentsPanel}},[_c('div',{class:[
      'flex',
      'items-end',
      {
        'text-dark-text-300': _vm.colorScheme === 'light',
        'text-light-text-300': _vm.colorScheme === 'dark',
      } ]},[_c('oz-icon',{attrs:{"name":"comment-outline","size":18}}),_vm._v(" "),_c('span',{class:[
        'text-12-16',
        'font-sans ml-0.5',
        {
          'text-dark-text-300': _vm.colorScheme === 'light',
          'text-light-text-300': _vm.colorScheme === 'dark',
        } ]},[_vm._v(_vm._s(_vm.commentsListLength))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }